export enum MetadataType {
  BOOK_TYPE = 'bookType', INDEX_TYPE = 'indexType', DATE_RANGE = 'dateRange', INDEX_BOOK = 'indexBook', BOOK = 'book'
}
